import React from 'react';
import BaseFilter from './base_filter';
import FilterSelect from '../partners/filter_select';
import { SETTING_OPTIONS, FILTER_OPTIONS } from './filter_constants_and_helpers';
import _ from "lodash";

class SettingDropdownFilter extends BaseFilter {

    constructor(props) {
        super(props)

		this.settingOtherIndex = FILTER_OPTIONS.setting.find(o => o.system_name === 'jewelry_style_ring_other').id

        Object.assign(this.state,this.stored || this._defaultValue())
        this._setDefault = this._setDefault.bind(this)

        // get visible options from all options.
        this.options = SETTING_OPTIONS.map(e => {
            return FILTER_OPTIONS.setting.find(s => s.pretty_name === e)
        })

        this.updateByItemProp = true

        this._setFiltersInternal = this._setFiltersInternal.bind(this)
        this.removeFilter = this.removeFilter.bind(this)
    }

    removeFilter(name) {
        if ( name ) {
            let newState = []
            const filterName = name.replace(' setting','')
            const filterId = this.options.find(o => o.pretty_name === filterName).id

            // is the current state using in or not in?
            if ( this.state.in.length ) {
                newState = this.state.in.filter(f => f !== filterId)
            } else {
                // using not in - did we remove other?
                if ( filterName === "Other" ) {
                    newState = this.options.filter(o => !this.state.not_in.includes(o.id)).map(o => o.id)
                } else {
                    newState = [...this.state.not_in]
                    newState.push(filterId)
                }
            }
            this._setFiltersInternal(SettingDropdownFilter.getFilterName(), newState)
        } else {
            this._setDefault()
        }
    }

    /**
     * The following set of function starting with _ are 'protected' and should be called by the base class only.
     * @private
     */
    _defaultValue() {
        return {in:[], not_in: []}
    }

    _setDefault() {
        this.setFilters(SettingDropdownFilter.getFilterName(),this._defaultValue())
    }

    _setFiltersInternal(filterName,newValue) {
		let value = {in: newValue, not_in: [] }
		if ( newValue.includes(this.settingOtherIndex) ) {
			value.not_in = this.options.map(o => o.id).filter(o => !newValue.includes(o))
		} 
        this.setFilters(filterName,value,this.removeFilter)
    }

    _itemValue(itemFilters) {
        return {in: itemFilters && itemFilters.setting || [], not_in: []}
    }

    _render() {
        return <FilterSelect
            label={"Setting"}
            name={SettingDropdownFilter.getFilterName()}
            options={this.options}
            route={"recent_deals_"+this.props.itemType}
            selectedOptions={this.state.in}
            setFilters={this._setFiltersInternal}
            systemName={SettingDropdownFilter.getFilterName()}
        />
    }

    _getFilterValue() {
        return {in:this.state.in, not_in: this.state.not_in}
    }

    _getFilterName() {
        return SettingDropdownFilter.getFilterName()
    }

    _tagName(newState) {
        let tagList = []
        for ( let id of newState.in ) {
            tagList.push(this.options.find(e => e.id == id).pretty_name + " setting")
        }
        return tagList
    }

    _apiKeys() {
        return ["in", "not_in"]
    }

    /**
     * static functions to be supported without an instance for generic filter usage implementations.
     * @returns {string}
     */
    static getFilterName() {
        return "style" // that's the name of the setting in the jewelry_properties table.
    }
}

export default SettingDropdownFilter;